import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  category: {
    id: 'CurrentRaportsMd.category',
    defaultMessage: 'Kategoria:'
  }
});



// WEBPACK FOOTER //
// ./src/views/CurrentReports/CurrentReportsMd.intl.js